// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"258563ce893483e1f31e","655":"037ea963a532a6df86f4"}[chunkId] + ".js";
};